/*
 * @Descripttion: 
 * @Author: zhaozheng
 * @Version: 0.0.1
 * @Date: 2025-11-17 10:51:26
 * @LastEditors: zhaozheng
 * @LastEditTime: 2025-11-19 10:45:19
 */
import React, { createContext, useContext } from 'react';

export type BgPalette = [string, string, string];

type BgControlContextValue = {
  setOverridePalette: (palette: BgPalette | null) => void;
  setModalOpen: (open: boolean) => void;
};

export const BgControlContext = createContext<BgControlContextValue | null>(null);

export const useBgControl = () => useContext(BgControlContext);

